/* FAQ accordion — self-contained, works on any template (incl. PageFly).
   Smooth height animation that works cross-browser. Padding lives on the inner
   wrapper (constant), so measuring scrollHeight is stable -> no jump/jerk.
   Delegated events so it also handles content injected after load. */
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.faq-block-question');
    if (!button) return;
    var item = button.closest('.faq-block-item');
    if (!item) return;
    var answer = item.querySelector('.faq-block-answer');
    if (!answer) return;

    if (item.classList.contains('open')) {
      // Close: pin current pixel height, force reflow, then collapse to 0.
      answer.style.height = answer.scrollHeight + 'px';
      void answer.offsetHeight; // reflow
      item.classList.remove('open');
      answer.style.height = '0px';
    } else {
      // Open: animate to content height, then switch to auto for responsiveness.
      item.classList.add('open');
      answer.style.height = answer.scrollHeight + 'px';
      var onEnd = function () {
        if (item.classList.contains('open')) answer.style.height = 'auto';
        answer.removeEventListener('transitionend', onEnd);
      };
      answer.addEventListener('transitionend', onEnd);
    }
  });
})();
